import type { PagesConfig } from '#types/config/pages'

export default {
  brandClasses: {
    header: 'my-3 px-4 lg:(mb-2 mt-5 px-6)',
    noResultsMessage: 'body-5 mt-1',
    noResultsMessageInitialQuery: 'italic',
    productCount: 'body-5 text-right self-end lg:hidden',
    title: 'body-5 c-grey-20',
    titleQuery: 'subtitle-2 c-brand-4 block'
  },
  defaultSearchTerm: 'Timberland'
} satisfies PagesConfig['search']
